// extracted by mini-css-extract-plugin
module.exports = {"titleDate":"DashboardScreen_titleDate__35kLL","chartCards":"DashboardScreen_chartCards__2uEke"};